import legalDocuments from '../legacy/organisms/legal-documents/legal-documents';

function onLoad() {
  legalDocuments.init();
}

if (document.readyState === 'complete') {
  onLoad();
} else {
  window.addEventListener('load', onLoad, { once: true });
}
